import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function Hero() {
  const scrollToCTA = () => {
    document.getElementById('final-cta')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-14 pb-12 md:pt-32 md:pb-24 overflow-hidden" data-id="element-116">
      <div className="absolute inset-0 bg-gradient-to-b from-cream-200/50 to-transparent -z-10" data-id="element-117" />

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-118">
        <div className="grid lg:grid-cols-2 gap-8 items-center" data-id="element-119">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="max-w-2xl" data-id="element-120">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-amber-100 text-amber-800 font-medium text-sm mb-4 md:mb-6" data-id="element-121">
              <ShieldCheckIcon size={16} data-id="element-122" />
              <span data-id="element-123">Método probado y seguro</span>
            </div>

            <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-charcoal leading-tight mb-6" data-id="element-124">
              ¿Te da pánico revisar el celular y encontrar un mensaje de tu
              vecino quejándose por los gritos de tu perro?
            </h1>

            <p className="text-xl md:text-2xl text-charcoal-light mb-6 md:mb-8 leading-relaxed" data-id="element-125">
              Recuperá la libertad de salir de tu casa sin la culpa de dejar a
              un perro sufriendo, ni el miedo a recibir una denuncia por ruidos
              molestos.
            </p>

            <button onClick={scrollToCTA} className="w-full sm:w-auto px-8 py-4 bg-amber-500 hover:bg-amber-600 text-white text-lg font-bold rounded-xl shadow-lg shadow-amber-500/30 transition-all hover:-translate-y-1 hover:shadow-xl" data-id="element-126">
              QUIERO RECUPERAR MI PAZ
            </button>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative lg:ml-auto" data-id="element-127">
            <div className="absolute inset-0 bg-amber-200/30 rounded-[2.5rem] blur-3xl -z-10 transform rotate-3 scale-105" data-id="element-128" />
            <img src="https://cdn.magicpatterns.com/uploads/cca8uzj4eUeZWgP3F9QSWk/MOCKUP.png" alt="Protocolo Cero Aullidos Mockup" className="w-full max-w-md mx-auto lg:max-w-full rounded-2xl shadow-2xl object-cover" data-id="element-129" />
          </motion.div>
        </div>
      </div>
    </section>;
}